import ISvgProps from '../SvgLoader/ISvgProps';
import { FC } from 'react';

export const OpenCheckImageIconWithoutBackground: FC<ISvgProps> = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
			<path
				d="M10.2591 9.85419L13 12.5945L12.0945 13.5L9.35419 10.7591C8.33458 11.5764 7.06636 12.021 5.75958 12.0192C2.58029 12.0192 0 9.43886 0 6.25958C0 3.08029 2.58029 0.5 5.75958 0.5C8.93886 0.5 11.5192 3.08029 11.5192 6.25958C11.521 7.56636 11.0764 8.83458 10.2591 9.85419ZM8.97534 9.37934C9.78751 8.54413 10.2411 7.42456 10.2392 6.25958C10.2392 3.78424 8.23427 1.77991 5.75958 1.77991C3.28424 1.77991 1.27991 3.78424 1.27991 6.25958C1.27991 8.73427 3.28424 10.7392 5.75958 10.7392C6.92456 10.7411 8.04413 10.2875 8.87934 9.47534L8.97534 9.37934ZM5.11962 5.61962V3.69976H6.39953V5.61962H8.31939V6.89953H6.39953V8.81939H5.11962V6.89953H3.19976V5.61962H5.11962Z"
				fill="#4657F4"
			/>
		</svg>
	);
};
